import {
  Accordion,
  Box,
  Flex,
  FlexProps,
  Text,
  TextProps,
} from "@chakra-ui/react";
import React from "react";
import ProfileSection from "./ProfileINISections/ProfileSection";
import PurchasedSection from "./ProfileINISections/PurchasedSection";
import HistorySection from "./ProfileINISections/HistorySection";

const UserProfileINI = ({
  profileHeaderWrapperProps,
  profileHeaderProps,
  ...rest
}: {
  profileHeaderWrapperProps?: FlexProps;
  profileHeaderProps?: TextProps;
}) => {
  return (
    <Box mt={"50px"}>
      <Box
        margin={"auto"}
        maxWidth={{
          base: "100%",
          lg: "100%",
          xl: "992px",
          "2xl": "1248px",
        }}
      >
        <Flex
          justifyContent={"center"}
          mb={"20px"}
          {...profileHeaderWrapperProps}
        >
          <Text
            color={"primary.500"}
            fontSize={"60px"}
            lineHeight={"38px"}
            textTransform={"uppercase"}
            {...profileHeaderProps}
          >
            My Tickets
          </Text>
        </Flex>
        <Box border={"3px solid #b4b6b6"} borderRadius={"5px"}>
          <ProfileSection {...rest} />
          <Accordion defaultIndex={[0]}>
            <PurchasedSection {...rest} />
            {/* <BookedSection {...rest} /> */}
            <HistorySection {...rest} />
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default UserProfileINI;
